import { render, staticRenderFns } from "./dashboard-company.vue?vue&type=template&id=35ba0b09&scoped=true&"
import script from "./dashboard-company.vue?vue&type=script&lang=js&"
export * from "./dashboard-company.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-company.vue?vue&type=style&index=0&id=35ba0b09&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "35ba0b09",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {Menu: require('/workspace/components/Menu/menu.vue').default})
